import interceptors from "./interceptors/index";

const saveSkirts = (items) => {
  return interceptors({
    url: "/online-promocional/documents/menu",
    method: "POST",
    data: { items },
  });
};

const fetchSkirts = () => {
  // return Promise.resolve({
  //   data: {
  //     menu: {
  //       items: [
  //         {
  //           abb: "CAT",
  //           code: "CAT",
  //           droppable: true,
  //           id: "1001",
  //           parent: "0",
  //           path: "/categoria",
  //           title: "categoria"
  //         },
  //         {
  //           abb: "ACT",
  //           code: "CAT-ACT",
  //           droppable: true,
  //           id: "2002",
  //           parent: "1001",
  //           path: "/actualizacion",
  //           title: "actualizacion"
  //         },
  //         {
  //           abb: "LIQ",
  //           code: "LIQ",
  //           droppable: true,
  //           id: "3003",
  //           parent: "0",
  //           path: "/liquidaciones",
  //           title: "liquidaciones"
  //         },
  //         {
  //           abb: "DES",
  //           code: "LIQ-DES",
  //           droppable: true,
  //           id: "4004",
  //           parent: "3003",
  //           path: "/descuentos",
  //           title: "descuentos"
  //         }
  //       ],
  //       name: "",
  //       timestamp: "2025-11-25 11:20:45.923395",
  //       type: "MENU",
  //       uuid: "MENU"
  //     }
  //   },
  //   error: null
  // });
  
  return interceptors({
    url: "/online-promocional/documents/menu",
    method: "GET",
  });
};

export { saveSkirts, fetchSkirts };
